// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "./componentes/Login";
import RequireAuth from "./componentes/Auth/RequireAuth";
import RequirePermission from "./componentes/Auth/RequirePermission";
import ErrorBoundary from "./componentes/common/ErrorBoundary";
import AppLayout from "./componentes/AppLayout/AppLayout";
import Dashboard from "./componentes/Dashboard";
import Clientes from "./componentes/ClientsComponent";
import NuevoCliente from "./componentes/NuevoCliente/NuevoCliente";
import EditarCliente from "./componentes/EditarCliente/EditarCliente";
import ClienteDetalle from "./componentes/ClienteDetalle/ClienteDetalle";
import DeudasCliente from "./componentes/DeudasCliente/DeudasCliente";
import AgregarDeuda from "./componentes/AdDeuda/AgregarDeuda";
import DetalleDeuda from "./componentes/DeudaDetalle/DetalleDeuda";
import RegistrarPago from "./componentes/RegistrarPago/RegistrarPago";
import GestionUsuarios from "./componentes/GestionDeUsuarios/GestionUsuarios";
import Auditoria from "./componentes/Auditoria/Auditoria";
import AgendaDiaria from "./componentes/AgendaDiaria/AgendaDiaria";
import EditarDeuda from "./componentes/AdDeuda/EditarDeuda";
import ListaPropiedades from "./componentes/Propiedades/ListaPropiedades";
import NuevaPropiedad from "./componentes/Propiedades/NuevaPropiedad";
import DetallePropiedad from "./componentes/Propiedades/DetallePropiedad";
import EditarPropiedad from "./componentes/Propiedades/EditarPropiedad";
import NuevoFraccionamiento from "./componentes/Propiedades/NuevoFraccionamiento";

import AgendaVencida from "./componentes/AgendaVencida/AgendaVencida";

// Comisiones (admin — F2/F6)
import ComisionistasList from "./componentes/Comisiones/ComisionistasList";
import ComisionistaForm from "./componentes/Comisiones/ComisionistaForm";
import ComisionistaDetalle from "./componentes/Comisiones/ComisionistaDetalle";
import ComisionesDashboard from "./componentes/Comisiones/ComisionesDashboard";

import ProveedoresList from "./componentes/Proveedores/ProveedoresList";
import ProveedorForm from "./componentes/Proveedores/ProveedorForm";
import ProveedorDetalle from "./componentes/Proveedores/ProveedorDetalle";
// Agenda Previsoria
import AgendaPrevisoria from "./componentes/AgendaPrevisoria/AgendaPrevisoria";



// HUB Gestión interna
import GestionInterna from "./componentes/GestionInterna/GestionInterna";

import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./Firebase/firebaseconfig";

import SociosList from "./componentes/Socios/SociosList";
import SocioForm from "./componentes/Socios/SocioForm";
import SocioDetalle from "./componentes/Socios/SocioDetalle";

const TicketsList = React.lazy(() => import("./componentes/Tickets/TicketsList"));
const TicketQuickNew = React.lazy(() => import("./componentes/Tickets/TicketQuickNew"));
const TicketDetail = React.lazy(() => import("./componentes/Tickets/TicketDetail"));

// Proyectos
const ProyectosHome = React.lazy(() => import("./componentes/Proyectos/ProyectosHome"));
const ProyectosDrive = React.lazy(() => import("./componentes/Proyectos/ProyectosDrive"));
const ProyectoCaja = React.lazy(() => import("./componentes/Proyectos/ProyectoCaja"));
const CajaGeneral = React.lazy(() => import("./componentes/Cajas/CajaGeneral"));

// Obras
const ObrasHome = React.lazy(() => import("./componentes/Obras/ObrasHome"));
const ObraDetalle = React.lazy(() => import("./componentes/Obras/ObraDetalle"));

// Diagnóstico
const DiagnosticoPermisos = React.lazy(() => import("./componentes/Diagnostico/DiagnosticoPermisos"));

// Portal del comisionista (layout dedicado sin sidebar)
const ComisionistaLayout = React.lazy(() => import("./componentes/MiCuenta/ComisionistaLayout"));
const MiCuenta = React.lazy(() => import("./componentes/MiCuenta/MiCuenta"));
const MiCuentaDetalle = React.lazy(() => import("./componentes/MiCuenta/MiCuentaDetalle"));

// Detalle de comisión individual (admin)
const ComisionDetalle = React.lazy(() => import("./componentes/Comisiones/ComisionDetalle"));

// Apartados (reservas 30 días)
const ListaApartados = React.lazy(() => import("./componentes/Apartados/ListaApartados"));

// Hub teléfonos inválidos (revisión de tels marcados como no contactables)
const TelefonosInvalidos = React.lazy(() => import("./componentes/Telefono/TelefonosInvalidos"));

// Reportes ejecutivos
const ReportesEjecutivos = React.lazy(() => import("./componentes/Reportes/ReportesEjecutivos"));

// Seguimiento de cobranza (panel de promesas y gestiones)
const SeguimientoCobranza = React.lazy(() => import("./componentes/Cobranza/SeguimientoCobranza"));

// CxP (cuentas por pagar)
const CxpAgenda = React.lazy(() => import("./componentes/cxpAgenda/CxpAgenda"));
const DetalleCxp = React.lazy(() => import("./componentes/cxpAgenda/DetalleCxp"));
const CxpForm = React.lazy(() => import("./componentes/cxpAgenda/CxpForm"));

// ERP
const ERPHome = React.lazy(() => import("./componentes/ERP/ERPHome"));
const ERPDetalleFinanciero = React.lazy(() => import("./componentes/ERP/ERPDetalleFinanciero"));
const CobranzaInteligente = React.lazy(() => import("./componentes/CobranzaInteligente/CobranzaInteligente"));
const ConfiguracionEmpresa = React.lazy(() => import("./componentes/Configuracion/ConfiguracionEmpresa"));
const CalidadDatos = React.lazy(() => import("./componentes/CalidadDatos/CalidadDatos"));
const ErroresRecientes = React.lazy(() => import("./componentes/common/ErroresRecientes"));
const PlanDiaUnificado = React.lazy(() => import("./componentes/PlanDia/PlanDiaUnificado"));

// Portal del Cliente (MAQUETA pública — datos ficticios, sin Firebase/Auth).
// Ruta independiente del panel real; /portal ya lo usa el portal del comisionista.
const PortalCliente = React.lazy(() => import("./componentes/PortalCliente/PortalCliente"));


const withPermission = (permission, element, message) => (
  <RequirePermission
    permission={Array.isArray(permission) ? undefined : permission}
    permissions={Array.isArray(permission) ? permission : undefined}
    message={message}
  >
    <ErrorBoundary label="esta seccion">
      <React.Suspense fallback={<div style={{ padding: "1.5rem" }}>Cargando modulo...</div>}>
        {element}
      </React.Suspense>
    </ErrorBoundary>
  </RequirePermission>
);

const App = () => {
  const [user, setUser] = React.useState(null);
  const [userRol, setUserRol] = React.useState("colaborador");

  React.useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u || null);
      if (u?.uid) {
        try {
          const snap = await getDoc(doc(db, "usuarios", u.uid));
          setUserRol(snap.exists() ? (snap.data().rol || "colaborador") : "colaborador");
        } catch {
          setUserRol("colaborador");
        }
      } else {
        setUserRol("colaborador");
      }
    });
    return () => unsub();
  }, []);

  return (
    <Routes>

    
      {/* Pública */}
      <Route path="/" element={<Login />} />

      {/* Portal del Cliente — MAQUETA pública (datos ficticios, sin auth/Firebase) */}
      <Route
        path="/portal-cliente"
        element={
          <React.Suspense fallback={<div style={{ padding: "1.5rem" }}>Cargando…</div>}>
            <PortalCliente />
          </React.Suspense>
        }
      />

      {/* Portal del comisionista — namespace dedicado /portal, sin sidebar */}
      <Route element={<RequireAuth />}>
        <Route
          path="portal"
          element={
            <React.Suspense fallback={<div style={{ padding: "1.5rem" }}>Cargando…</div>}>
              <ComisionistaLayout />
            </React.Suspense>
          }
        >
          <Route
            index
            element={<Navigate to="mi-cuenta" replace />}
          />
          <Route
            path="mi-cuenta"
            element={withPermission("comisiones.miCuenta.ver", <MiCuenta />)}
          />
          <Route
            path="mi-cuenta/:comisionId"
            element={withPermission("comisiones.miCuenta.ver", <MiCuentaDetalle />)}
          />
        </Route>
      </Route>

      {/* Protegidas */}
      <Route element={<RequireAuth />}>
        <Route path="app" element={<AppLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="proveedores" element={withPermission("proveedores.ver", <ProveedoresList />)} />
          <Route path="/app/proveedores/nuevo" element={withPermission("proveedores.crear", <ProveedorForm />)} />
          <Route path="/app/proveedores/:provId" element={withPermission("proveedores.ver", <ProveedorDetalle />)} />
          <Route path="/app/proveedores/:provId/editar" element={withPermission("proveedores.editar", <ProveedorForm edit />)} />
          {/* Dashboard */}
          <Route path="dashboard" element={<ErrorBoundary label="el dashboard"><Dashboard /></ErrorBoundary>} />
          {/*Proyectos */}
          <Route path="/app/proyectos" element={withPermission("proyectos.ver", <ProyectosHome />)} />
          <Route path="/app/proyectos/:proyectoId/drive" element={withPermission("proyectos.ver", <ProyectosDrive />)} />
          <Route path="/app/proyectos/:proyectoId/caja" element={withPermission("cajas.ver", <ProyectoCaja />)} />
          <Route path="/app/cajas/general" element={withPermission(["cajas.general.ver", "cajas.ver"], <CajaGeneral />)} />
          {/* Gestión interna (HUB) */}
          <Route path="interna" element={withPermission("gestionInterna.ver", <GestionInterna />)} />
          <Route path="configuracion-empresa" element={withPermission("gestionInterna.ver", <ConfiguracionEmpresa />)} />
          <Route path="calidad-datos" element={withPermission("gestionInterna.ver", <CalidadDatos />)} />
          <Route path="errores-recientes" element={withPermission("gestionInterna.ver", <ErroresRecientes />)} />
          <Route path="plan-dia" element={withPermission("cobranzaInteligente.ver", <PlanDiaUnificado />, "Necesitas permiso de cobranza para ver el plan del día.")} />
          {/* Mantiene compatibilidad con links antiguos al modo conciliador */}
          <Route path="plan-dia/conciliador" element={withPermission("cobranzaInteligente.ver", <PlanDiaUnificado />, "Necesitas permiso de cobranza para ver el plan del día.")} />

          {/* Clientes / Deudas */}
          <Route path="clientes" element={withPermission("clientes.ver", <Clientes />)} />
          <Route path="nuevo-cliente" element={withPermission("clientes.crear", <NuevoCliente />)} />
          <Route path="cliente/:id/editar" element={withPermission("clientes.editar", <EditarCliente />)} />
          <Route path="cliente/:id" element={withPermission("clientes.ver", <ClienteDetalle />)} />
          <Route path="cliente/:id/deudas" element={withPermission("deudas.ver", <DeudasCliente />)} />
          <Route path="cliente/:id/deudas/nueva" element={withPermission("deudas.crear", <AgregarDeuda />)} />
          <Route path="cliente/:id/deudas/:deudaId" element={withPermission("deudas.ver", <DetalleDeuda />)} />
          <Route path="cliente/:id/deudas/:deudaId/pago" element={withPermission("deudas.registrarPago", <RegistrarPago />)} />
          {/* (corregido) relativa */}
          <Route path="cliente/:id/deudas/:deudaId/editar" element={withPermission("deudas.editar", <EditarDeuda />)} />

          {/* Agenda de cobros (clientes) */}
          <Route path="agenda" element={withPermission("agenda.ver", <AgendaDiaria />)} />
          <Route path="/app/agenda/vencida" element={withPermission("agenda.ver", <AgendaVencida />)} />

          {/* Cuentas por pagar (CxP) — rutas RELATIVAS */}
          <Route path="cxp" element={withPermission("cxp.ver", <CxpAgenda />)} />
          <Route path="cxp/nueva" element={withPermission("cxp.crear", <CxpForm />)} />
          <Route path="cxp/deudas/:deudaId" element={withPermission("cxp.ver", <DetalleCxp />)} />
          <Route path="cxp/deudas/:deudaId/editar" element={withPermission("cxp.editar", <CxpForm edit />)} />

          {/* Apartados (reservas 30 días) */}
          <Route path="apartados" element={withPermission("deudas.ver", <ListaApartados />)} />
          <Route path="telefonos-invalidos" element={withPermission("clientes.ver", <TelefonosInvalidos />)} />

          {/* Reportes ejecutivos */}
          <Route path="reportes" element={withPermission("reportes.ver", <ReportesEjecutivos />)} />

          {/* Seguimiento de cobranza */}
          <Route
            path="cobranza/seguimiento"
            element={withPermission("cobranza.promesas.ver", <SeguimientoCobranza />)}
          />

          {/* Comisiones — admin (F2/F6) */}
          <Route path="comisiones" element={withPermission("comisiones.ver", <ComisionesDashboard />)} />
          <Route path="comisiones/:comisionId" element={withPermission("comisiones.ver", <ComisionDetalle />)} />
          <Route path="comisionistas" element={withPermission("comisiones.ver", <ComisionistasList />)} />
          <Route path="comisionistas/nuevo" element={withPermission("comisionistas.gestionar", <ComisionistaForm />)} />
          <Route path="comisionistas/:comisionistaId" element={withPermission("comisiones.ver", <ComisionistaDetalle />)} />
          <Route path="comisionistas/:comisionistaId/editar" element={withPermission("comisionistas.gestionar", <ComisionistaForm edit />)} />

          {/* Socios */}
          <Route path="socios" element={withPermission("socios.ver", <SociosList />)} />
          <Route path="socios/nuevo" element={withPermission("socios.crear", <SocioForm />)} />
          <Route path="socios/:socioId" element={withPermission("socios.ver", <SocioDetalle />)} />
          <Route path="socios/:socioId/editar" element={withPermission("socios.editar", <SocioForm edit />)} />

          {/* Propiedades */}
          <Route path="propiedades" element={withPermission("propiedades.ver", <ListaPropiedades />)} />
          <Route path="propiedades/nueva" element={withPermission("propiedades.crear", <NuevaPropiedad />)} />
          <Route path="propiedades/:id" element={withPermission("propiedades.ver", <DetallePropiedad />)} />
          <Route path="propiedades/:id/editar" element={withPermission("propiedades.editar", <EditarPropiedad />)} />
          <Route path="propiedades/fraccionamiento/nuevo" element={withPermission("propiedades.crear", <NuevoFraccionamiento />)} />

          {/* Tickets */}
          <Route path="tickets" element={withPermission("tickets.ver", <TicketsList currentUser={user} />)} />
          <Route path="tickets/new" element={withPermission("tickets.crear", <TicketQuickNew currentUser={user} />)} />
          <Route path="tickets/:id" element={withPermission("tickets.ver", <TicketDetail currentUser={user} userRole={userRol} />)} />

          {/* Gestión de usuarios */}
          <Route path="usuarios" element={withPermission("usuarios.ver", <GestionUsuarios />)} />
          <Route path="auditoria" element={withPermission("auditoria.ver", <Auditoria />)} />

          {/*ERP */}
          <Route path="erp" element={withPermission("erp.ver", <ERPHome />)} />
          <Route path="erp/:tipo/:id" element={withPermission("erp.ver", <ERPDetalleFinanciero />)} />
          
          {/* Obras */}
          <Route path="/app/obras" element={withPermission("obras.ver", <ObrasHome />)} />
          <Route path="/app/obras/:obraId" element={withPermission("obras.ver", <ObraDetalle />)} />
          {/* Agenda Previsoria*/}
          <Route path="/app/agenda/previsoria" element={withPermission("agenda.ver", <AgendaPrevisoria />)} />

        <Route path="/app/cobranza/inteligente" element={withPermission("cobranzaInteligente.ver", <CobranzaInteligente />)} />

          {/* Diagnóstico de permisos — accesible a cualquier sesión autenticada */}
          <Route path="diagnostico-permisos" element={
            <React.Suspense fallback={<div style={{ padding: "1.5rem" }}>Cargando...</div>}>
              <DiagnosticoPermisos />
            </React.Suspense>
          } />



        </Route>
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
